import React, { useState, forwardRef } from 'react';
import {InputDefaultLabel, InputDefaultMessageError } from './styles';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {
    InputPasswordContainer,
    InputPasswordLabel,
    InputPasswordField,
    InputPasswordMessageError,
    TogglePasswordButton
  } from './styles';

const InputPassword = forwardRef(({ label, error, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputPasswordContainer id="input-password">
      <InputPasswordLabel htmlFor={props.id}>{label}</InputPasswordLabel>
      <div style={{ position: 'relative' }}>
        <InputPasswordField
          {...props}
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          className={error && 'error'}
        />
        <TogglePasswordButton onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </TogglePasswordButton>
      </div>
      {error && <InputPasswordMessageError error={error}>{error.message}</InputPasswordMessageError>}
    </InputPasswordContainer>
  );
});

export default InputPassword;

  